
































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditMoistureEquipment from "./edit-moiepuipment.vue";
import CreateMoistureEquipment from "./create-moiequipment.vue";
class PageMoistureEquipmentRequest extends PageRequest {
  snid:string;
}
class PageCompanyRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
}

@Component({
  components: {EditMoistureEquipment,CreateMoistureEquipment},
})
export default class MoistureEquipments extends AbpBase {
  pagerequest: PageMoistureEquipmentRequest = new PageMoistureEquipmentRequest();
  publicpagerequest: PageMoistureEquipmentRequest = new PageMoistureEquipmentRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
  cId:Number;
  selwarehouselist = [];
  selfloorlist = [];   
  get list() {
    return this.$store.state.moistureequipment.list;
  }
  get loading() {
    return this.$store.state.moistureequipment.loading;
  }
  pageChange(page: number) {
    this.$store.commit("moistureequipment/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("moistureequipment/setPageSize", pagesize);
    this.getPage();
  }
  getsearch(){
    this.$store.state.moistureequipment.currentPage = 1;
    this.getPage();

  }
  async getPage() {
    this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    
    //filters
    await this.$store.dispatch({
      type: "moistureequipment/getPaged",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.moistureequipment.pageSize;
  }
  get totalCount() {
    return this.$store.state.moistureequipment.totalCount;
  }
  get currentPage() {
    return this.$store.state.moistureequipment.currentPage;
  }
  getuserName() {
    // console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  // get warehouse() {
  //   return this.$store.state.warehouse.list;
  // }
   warehouselist() {
    return this.$store.state.warehouse.list;                                                                                                                    
  }
  // get floor() {
  //   return this.$store.state.floor.list;
  // }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }
   get smokecrib() {
    return this.$store.state.smokecrib.list;
  }
  smokecriblist(){
    return this.$store.state.smokecrib.list;
  }
  get moisturethreshold(){
    return this.$store.state.moisturethreshold.list
  }
  moisturethresholdlist(){
    return this.$store.state.moisturethreshold.list;
  }
  
  selCompany(value:Number){
    this.pagecompanyrequest.cId = value;
    this.getfactory();
    this.getwarehouse();
      this.getfloor();
    this.$store.state.moistureequipment.currentPage = 1;
       this.getPage();
  }
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
    this.$store.state.moistureequipment.currentPage = 1;
       this.getPage();
  }
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
        this.$store.state.moistureequipment.currentPage = 1;
       this.getPage();
  }
  selfloor(value:Number){
    this.$store.state.moistureequipment.currentPage = 1;
       this.getPage();
  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房",
      key: "wId",
       render: (h, params) => {
        let wId = params.row.wId;
        let clist = this.warehouselist();
        //console.log(clist); 
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(wId==entry.id){
            wId=entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let clist = this.floorlist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(fId==entry.id){
            fId=entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "snid",
      // sortable: true,
    },
    {
      title: "烟叶",
      key: "scId",
      render: (h, params) => {
        let scId = params.row.scId;
        let clist = this.smokecriblist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(scId==entry.id){
            scId=entry.title;
            break;
          }
        }
        return h("span", scId);
      },
    },
    {
      title: "垛位号",
      key: "locationName",
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.$store.commit("moistureequipment/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "moistureequipment/delete",
                        data: params.row,
                      });
                      await this.getPage();
                    },
                  });
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll"
    });
   
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
   async getmoisturethreshold(){
      //阈值方案
    //filters
    await this.$store.dispatch({
      type: "moisturethreshold/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getgwequipment() {
    //网关
    //filters
    await this.$store.dispatch({
      type: "gwequipment/getAll",
       data: this.pagecompanyrequest,
    });
  }
 async getsmokecrib(){
   //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
       data: this.pagecompanyrequest,
    });
 }
 created() {
   this.$store.state.moistureequipment.pageSize=10;
    this.$store.state.moistureequipment.currentPage=1;
    this.$store.state.moistureequipment.totalCount=0;
    this.getuserName();
      this.getwarehouse();
      this.getfloor();
      this.getfactory();
      this.getmoisturethreshold();
      this.getgwequipment();
      this.getsmokecrib();
    if (this.userName !== "admin") {
            //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getPage();
    
  }
}
